import { render, staticRenderFns } from "./MakeAnEntryJournalText.vue?vue&type=template&id=80cb32a2&lang=pug&"
import script from "./MakeAnEntryJournalText.vue?vue&type=script&lang=js&"
export * from "./MakeAnEntryJournalText.vue?vue&type=script&lang=js&"
import style0 from "./MakeAnEntryJournalText.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports